"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const tyre_search_1 = require("../../components/ProductSearch/tyre-search");
const TyreFilter_vue_1 = __importDefault(require("../../components/ProductSearch/TyreFilter.vue"));
const i18n_1 = require("../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProductSpareWheel',
    setup(__props) {
        const route = (0, vue_router_1.useRoute)();
        const form = (0, vue_3.ref)(Object.assign({}, tyre_search_1.spareWheelSearchForm));
        const initQueryParams = (0, tyre_search_1.getQueryParams)(form.value, route);
        for (const key in initQueryParams) {
            if (Object.prototype.hasOwnProperty.call(initQueryParams, key)) {
                form.value[key] = initQueryParams[key];
            }
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TyreFilter_vue_1.default, {
                "search-label": (0, vue_2.unref)(i18n_1.trans)('spare_wheel_search', 'Spare wheel search', 'spare_wheels'),
                form: form.value,
                placeholder: (0, vue_2.unref)(i18n_1.trans)('tag_search_input_placeholder', 'eg. 125/80R17', 'spare_wheels'),
                category: "spareWheel"
            }, null, 8, ["search-label", "form", "placeholder"]));
        };
    }
});
